import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1962180f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "question-detail aio-question-detail",
  "talqs-app": ""
}
const _hoisted_2 = { class: "m-section-title u-top" }
const _hoisted_3 = {
  key: 0,
  class: "u-desc"
}
const _hoisted_4 = ["id"]
const _hoisted_5 = {
  key: 0,
  class: "u-remarks"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["m-que-section", `m-que-section-${$props.retryNum}`])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(_toDisplayString(`${$setup.queTypeDes}题`) + " ", 1),
        ($props.showTotal)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "共" + _toDisplayString($setup.total) + "小题", 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: "m-section-content question-title",
        id: `questionTitle_${$props.questionIndex}`
      }, null, 8, _hoisted_4),
      ($setup.isDecidable !== 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, "注：此题暂不支持判题"))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}